export enum TimerType {
    CountUp,
    CountDown,
}
